import { takeEvery } from 'redux-saga/effects';

import { simpleRequest } from 'modules/app/utils';

import * as types from './actionTypes';

export default function* bodyScanSagas() {
  yield takeEvery(types.SEARCH_BODY_SCANS_REQUEST, simpleRequest);
}
